{<template>
  <el-dialog :visible.sync="isModalVisible" :show-close="false" :close-on-click-modal="false" width="68%">
    <span slot="title" class="font-weight-bold h4">
      <div class="d-flex justify-content-between">
        <span> Add Order Numbers </span>
      </div>
    </span>
    <div class="pl-1 pt-2" style="margin-top: -20px !important;">
      <span class="h6">
        Add order numbers below for each line item or group of items in the order.
      </span>
      <br />
      <span class="h6">
        Confirming the order will send an email notification to the buyer. You also can include an optional message using the form below.
      </span>
    </div>
    <el-row class="py-4">
      <el-col :span="24">
        <el-form
              ref="form"
              :model=" { getOffers }"
              label-position="top"
            >
            <el-table
              :data="getOffers"
              :fit="true"
              size="mini"
              :header-cell-class-name="tableHeaderClass"
            >
              <el-table-column align="left" label="Product" min-width="100px">
                <template slot-scope="scope">
                  <span>{{ scope.row.fuel }}</span>
                </template>
              </el-table-column>
              <el-table-column align="left" label="Vol/L" min-width="100px">
                <template slot-scope="scope">
                  <span>{{ scope.row.quantity }}</span>
                </template>
              </el-table-column>
              <el-table-column align="left" label="Order No." min-width="100px">
                <template slot-scope="scope">
                  <el-form-item
                    :prop="'getOffers.' + scope.$index + '.contractNumber'"
                    class="pt-3 pb-2"
                  >
                    <el-input
                      v-model="scope.row.contractNumber"
                    >
                    </el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column align="left" label="Release No." min-width="100px" v-if="!isBunkering">
                <template slot-scope="scope">
                  <el-form-item
                    class="pt-3 pb-2"
                  >
                    <el-input
                      v-model="scope.row.releaseNumber"
                    >
                    </el-input>
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column align="left" label="Movement No." min-width="100px" v-if="!isBunkering">
                <template slot-scope="scope">
                  <el-form-item
                    class="pt-3 pb-2"
                  >
                    <el-input
                      v-model="scope.row.movementNumber"
                    >
                    </el-input>
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
        </el-form>
      </el-col>
    </el-row>
    <el-row class="pt-2">
      <span class="font-weight-bold"> Optional Message </span>
    </el-row>
    <el-row type="flex" justify="center" class="pt-2">
      <el-col :span="24" class="text-center">
        <el-input type="textarea" :rows="6" placeholder="Enter message.." v-model="customerFeedback"> </el-input>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer-center">
      <el-row :gutter="20">
        <el-button size="small" type="info" @click="cancelSave"> {{ isComingFromOrderCapture ? 'Close' : 'Back' }}</el-button>
        <el-button size="small" type="success" @click="confirmSave" :loading="btnLoading">Confirm Order</el-button>
      </el-row>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import breakpoint from "@/mixins/index";
import { updateOrderStatus, updateOrderNumbers } from "@/api/orders";
import isEmpty from "lodash/isEmpty";
import isEqual from "lodash/isEqual";
export default {
  components: {},
  mixins: [breakpoint],
  props: {
    orderId: {
      type: String,
      required: true,
      default: "",
    },
    orderToUpdate: {
      type: Array,
      required: true,
      default: () => [],
    },
    isBunkering: {
      type: Boolean,
      required: false,
      default: true,
    },
    viewManageOrderNumbersDialog: {
      type: Boolean,
      required: false,
      default: true,
    },
    isComingFromOrderCapture: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  watch: {
    showItemRemovalConfirmation() {
      if (!this.showItemRemovalConfirmation) {
        this.isModalVisible = true;
        this.$emit("update:viewEditOrderDialogVisible", false);
        this.$store.dispatch("itemRemoval/confirmUnsavedChangesRemoval", false);
      }
    },
    unsavedChangesRemovalConfirmed() {
      if (this.unsavedChangesRemovalConfirmed) {
        this.$emit("update:viewManageOrderNumbersDialog", false);
        this.$store.dispatch("itemRemoval/confirmUnsavedChangesRemoval", false);
      }
    },
  },
  data() {
    return {
      unmodifiedOrderData: null,
      isConfirmingOrder: true,
      customerFeedback: "",
      orderData: null,
      btnLoading: false,
      isModalVisible: true,
      editOrderForm: {
        offers: [],
      },
    };
  },
  computed: {
    ...mapGetters("itemRemoval", ["showItemRemovalConfirmation", "unsavedChangesRemovalConfirmed"]),
    hasChangeOccured() {
      return !isEqual(this.unmodifiedOrderData, this.orderData);
    },
    isNegotiation: {
      get() {
        if(this.orderToUpdate && this.orderToUpdate.length === 1){
          return this.orderToUpdate[0].isNegotiation;
        }
        return false;
      }
    },
    getOffers() {
      if (!isEmpty(this.orderData)) {
        return this.orderData;
      } else {
        return [];
      }
    }
  },
  mounted() {
    this.unmodifiedOrderData = JSON.parse(JSON.stringify(this.orderToUpdate));
    this.unmodifiedOrderData.forEach(element => {
      element.contractNumber = element.contractNumber ? element.contractNumber : null,
      element.releaseNumber = element.releaseNumber ? element.releaseNumber : null,
      element.movementNumber = element.movementNumber ? element.movementNumber : null
    });
    this.orderData = JSON.parse(JSON.stringify(this.unmodifiedOrderData));
  },
  methods: {
    showRemovalConfirmation: function (isOpening) {
      if (isOpening) {
        this.isModalVisible = false;
        // Show removal confirmation modal
        const payload = {
          item: {},
          type: this.$store.getters["itemRemoval/eRemoveItemType"].UnconfirmedChanges,
          showWindow: true,
        };
        this.$store.dispatch("itemRemoval/openConfirmationRemoval", payload);
        setTimeout(() => {
          const removalModal = this.$root.$refs.confirmationRemoveItem.$el;
          $(removalModal).modal({ show: true, keyboard: false });
        }, 250);
      }
    },
    displayPreviousModal() {
      this.isModalVisible = false;
      setTimeout(() => {
        if (this.isComingFromOrderCapture) {
          this.$emit('closeEditOrderDialog')
        } else {
          this.$emit("update:viewEditOrderDialogVisible", true);
          this.$emit("update:viewManageOrderNumbersDialog", false);
        }
      }, 150);
    },
    cancelSave() {
      if (this.hasChangeOccured) {
        this.showRemovalConfirmation(true)
      } else {
        this.displayPreviousModal();
      }
    },
    generateOrderNumbersObject() {
      this.editOrderForm.offers = this.orderData.map(({offerId, contractNumber, releaseNumber, movementNumber}) => {
        return {
          _id: offerId,
          contractNumber,
          releaseNumber,
          movementNumber,
        };
      });
    },
    async confirmSave() {
      this.btnLoading = true;
      await this.generateOrderNumbersObject();
      const orderDto = this.isNegotiation ? 
        { negotiation: this.editOrderForm.offers[0]} : 
        { offers: this.editOrderForm.offers };
      updateOrderNumbers(this.orderId, orderDto).then(res => {
        updateOrderStatus(this.orderId, { status: "CONFIRMED", feedback: this.customerFeedback }).then(this.handleResponse)
      });
    },
    handleResponse(res) {
      if (res.status === 200) {
        this.btnLoading = false;
        this.$emit("closeEditOrderDialog");
      } else {
        this.displayPreviousModal();
      }
    },
    tableHeaderClass({ row, rowIndex }) {
      return "dark-header-row";
    },
  },
};
</script>
<style>
.el-dialog__body {
  padding-top: 10px;
}

.el-form--label-top .el-form-item__label {
  padding: 0px !important;
}
</style>}